/**
 * @generated SignedSource<<defc8fabb8957f6f38cf0d583062aa14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type BookTitlesFilter = {
  search?: string | null;
};
export type BookTitleSearchOverlayField_bookTitlesQuery$variables = {
  filters?: BookTitlesFilter | null;
};
export type BookTitleSearchOverlayField_bookTitlesQuery$data = {
  readonly bookTitles: ReadonlyArray<string>;
};
export type BookTitleSearchOverlayField_bookTitlesQuery = {
  response: BookTitleSearchOverlayField_bookTitlesQuery$data;
  variables: BookTitleSearchOverlayField_bookTitlesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filters",
        "variableName": "filters"
      }
    ],
    "kind": "ScalarField",
    "name": "bookTitles",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BookTitleSearchOverlayField_bookTitlesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BookTitleSearchOverlayField_bookTitlesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8d8abb7066a556e836d939acb0b3a512",
    "id": null,
    "metadata": {},
    "name": "BookTitleSearchOverlayField_bookTitlesQuery",
    "operationKind": "query",
    "text": "query BookTitleSearchOverlayField_bookTitlesQuery(\n  $filters: BookTitlesFilter\n) {\n  bookTitles(filters: $filters)\n}\n"
  }
};
})();

(node as any).hash = "7f163e3e0165d2514c1ffddc8f5d4d1e";

export default node;
